export default "__VITE_ASSET__BeRNtnSx__"